module.exports = __webpack_public_path__ + "img/download-zh.7f494597.png";